
import { defineComponent } from "vue";
import type { PropType } from "vue";
import LoadingSpinnerComponent from "@/components/generic/LoadingSpinnerComponent.vue";

/**
 * Loading / error / empty / content switch shared by list and table panels.
 * Precedence: loading, then error, then empty, otherwise the default slot.
 * `spinner="border"` (default) is the Bootstrap spinner the panels already used;
 * `spinner="component"` uses LoadingSpinnerComponent.
 */
export default defineComponent({
  name: "StateBlock",
  components: { LoadingSpinnerComponent },
  props: {
    loading: { type: Boolean, default: false },
    /** A message string or just `true` (then errorText is shown). */
    error: { type: [String, Boolean] as PropType<string | boolean>, default: false },
    empty: { type: Boolean, default: false },
    emptyText: { type: String, default: "" },
    errorText: { type: String, default: "" },
    /** Screen-reader label for the spinner (defaults to common.loading). */
    loadingText: { type: String, default: "" },
    spinner: { type: String as PropType<"border" | "component">, default: "border" },
    padding: { type: String, default: "py-4" },
  },
});
